import React, { useRef } from "react";
import { Box, Card } from '@curves/ui-base';

import useEChart from "@Util/hook/useEChart";
import ChartSkeletonLoading from "@Local/Dashboard/Components/ChartSkeletonLoading";
import { adaptPie } from "@Local/Dashboard/dashboard.util";
const COLOR_CONFIG = [{ color: "#4C0073" }, { color: "#7E2E9C" }, { color: "#94A3B8" }, { color: "#CBD5E1" }, { color: "#E2E8F0" }];
/********* 運動頻率分級 *********/
const WorkoutFrequencyLevel = React.forwardRef((props, ref) => {
	const chartDomRef = useRef(null);
	const { sourceData = { xAxis: ["A 會員-1個月", "B 會員~3個月", "C 會員", "D 會員", "E 會員"], data: [18, 22, 28, 20, 12] } } = props;
	const { data = [], centerValueText = "" } = adaptPie(sourceData, COLOR_CONFIG);
	const isLoading = data.length === 0;
	const title = "運動頻率分級";
	const subTitle = "每月運動次數分組比例";
	const option = {
		title: {
			text: title,
			subtext: subTitle,
			left: 24,
			top: 20,
			textStyle: {
				fontSize: 20,
				fontWeight: 600,
				color: "#1F2937",
			},
			subtextStyle: {
				fontSize: 14,
				color: "#64748B",
				padding: [8, 0, 0, 0],
			},
		},
		tooltip: {
			trigger: "item",
		},
		// --- 圖例 ---
		legend: {
			bottom: 20,
			left: "center",
			itemWidth: 14,
			itemHeight: 14,
			icon: "roundRect",
			textStyle: {
				fontSize: 14,
				fontWeight: 600,
				color: "#111827",
			},
		},
		graphic: [
			{
				type: "text",
				left: "center",
				top: "47%",
				style: {
					text: "A+B 佔比",
					fill: "#94A3B8",
					fontSize: 26,
					textAlign: "center",
				},
			},
			{
				type: "text",
				right: "47%",
				top: "55%",
				style: {
					text: `${centerValueText}`,
					fill: "#4C0073",
					fontSize: 36,
					fontWeight: 700,
					textAlign: "center",
				},
			},
			{
				type: "text",
				left: "53%",
				top: "58%",
				style: {
					text: "%",
					fill: "#4C0073",
					fontSize: 20,
					fontWeight: 600,
					textAlign: "left",
				},
			},
		],
		series: [
			{
				type: "pie",
				radius: ["45%", "65%"],
				center: ["50%", "55%"],
				padAngle: 3,
				avoidLabelOverlap: false,
				label: { show: false },
				labelLine: { show: false },
				itemStyle: {
					borderRadius: 8,
				},
				data: data,
			},
		],
	};
	useEChart(chartDomRef, option);
	return (
		<Card style={{ width: "100%", height: "100%" }}>
			<Card.CardContent style={{ width: "100%", height: "100%" }}>
				{isLoading ? <ChartSkeletonLoading /> : <Box ref={chartDomRef} style={{ width: "100%", height: "100%" }}></Box>}
			</Card.CardContent>
		</Card>
	);
});
export default WorkoutFrequencyLevel;
